export class DownloadedItem {
  url: string;
  fileName: string;
  blob: Blob;
}
